import { ApiProperty } from "@nestjs/swagger";

export class DocumentsUploadDto{
    @ApiProperty()
    documentsApprovalId?:number;
    @ApiProperty()
    customsInvoiceUploaded:boolean;
    @ApiProperty()
    commonInvoiceUploaded:boolean;
    @ApiProperty()
    commercialPackingListUploaded:boolean;
    @ApiProperty()
    commercialInvoiceUploaded:boolean;
    @ApiProperty()
    plantPackingListUploaded:boolean;
    @ApiProperty()
    plantInvoiceUploaded:boolean;
    @ApiProperty()
    shipmentInstructionsUploaded:boolean;
    @ApiProperty()
    form13sUploaded:boolean;
    @ApiProperty()
    bLDraftUploaded:boolean;
    @ApiProperty()
    freightInvoiceUploaded:boolean;
    @ApiProperty()
    oblUploaded:boolean;
    @ApiProperty()
    iSFWorksheetUploaded:boolean;
    @ApiProperty()
    sIMPUploaded:boolean;
    @ApiProperty()
    certificateOfOriginUploaded:boolean;
    @ApiProperty()
    declarationOfShrimpUploaded:boolean;
    @ApiProperty()
    healthCertificateUploaded:boolean;
    @ApiProperty()
    surveyReportUploaded:boolean;
    @ApiProperty()
    approverOneStatusUploaded:boolean;
    @ApiProperty()
    approverOne:string;
    @ApiProperty()
    approverTwoStatusUploaded:boolean;
    @ApiProperty()
    approverTwo:string;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    saleOrderNumber:string;
}